import React, { useState } from 'react';
import Banner from "../images/banner.png";
import "../styles/home.css";
import {
    Typography,
    Button,
    Box,
    Container,
    Card,
    CardContent,
    TextField
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from './AuthContext';
import Logo from "../images/nag_kitchen_logo.png";

export default function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const serviceAPI = process.env.REACT_APP_API_SERVICE;
    const { login } = useAuth();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        clearCookies();

        const loginData = { username, password };

        try {
            const response = await axios.post(
                `${serviceAPI}/auth/login`,
                loginData,
                { withCredentials: true }
            );

            if (response.status === 200) {
                const token = response.data.token;
                if (token) {
                    localStorage.setItem('jwt_token', token);
                    sessionStorage.setItem('jwt_token', token);
                    login();
                    navigate('/cateringOrders');
                } else {
                    setError('Login failed: No token received');
                }
            } else {
                setError('Login failed for user. Please retry!');
            }
        } catch (error) {
            setError('Error occurred. Please retry.');
        }
    };

    const clearCookies = () => {
        document.cookie = "JSESSIONID=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    };

    return (
        <Box
            sx={{
                backgroundImage: `url(${Banner})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0 16px", // Adjust padding for better responsiveness
            }}
        >
            <Card
                sx={{
                    width: '100%',
                    maxWidth: 400,
                    border: "2px solid #356",
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    backdropFilter: "blur(6px)",
                    boxShadow: 3,
                    padding: "24px",
                    borderRadius: "12px",
                }}
            >
                <CardContent>
                    <Box
                        component="form"
                        onSubmit={handleLogin}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                        }}
                    >
                        {/* Logo and Title */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: 2,
                            }}
                        >
                            <img
                                src={Logo}
                                alt="Logo"
                                style={{
                                    height: "60px",
                                    width: "auto",
                                    objectFit: "contain"
                                }}
                            />
                            <Typography variant="h5" sx={{ ml: 1, fontWeight: 'bold' }}>
                                Login
                            </Typography>
                        </Box>

                        {/* Error Message */}
                        {error && (
                            <Typography
                                variant="body2"
                                color="error"
                                align="center"
                                sx={{ marginBottom: 1 }}
                            >
                                {error}
                            </Typography>
                        )}

                        {/* Username Input */}
                        <TextField
                            label="Username"
                            variant="outlined"
                            fullWidth
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                },
                            }}
                        />

                        {/* Password Input */}
                        <TextField
                            label="Password"
                            variant="outlined"
                            type="password"
                            fullWidth
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                },
                            }}
                        />

                        {/* Login Button */}
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{
                                backgroundColor: '#356',
                                color: '#fff',
                                padding: '12px',
                                borderRadius: '8px',
                                fontWeight: 'bold',
                                '&:hover': {
                                    backgroundColor: '#2c4b5c',
                                },
                            }}
                        >
                            Login
                        </Button>

                        {/* Register Button */}
                        <Button
                            onClick={() => navigate("/registration")}
                            variant="outlined"
                            color="primary"
                            fullWidth
                            sx={{
                                padding: '12px',
                                borderRadius: '8px',
                                fontWeight: 'bold',
                                borderColor: '#356',
                                color: '#356',
                                '&:hover': {
                                    backgroundColor: '#f4f4f4',
                                    borderColor: '#2c4b5c',
                                    color: '#2c4b5c',
                                },
                            }}
                        >
                            Register
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
}
